<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :pagination.sync="defaultSort"
    class="elevation-1"
  >
    <template slot="items" slot-scope="{ item }">
      <tr :class="{ subtle: isExpired(item) }">
        <td class="text-xs-left">
          {{ item.certification_type }}
          <span v-show="item.notes">
            | {{ item.notes }}
          </span>
        </td>
        <td class="text-xs-right">{{ item.start_date | moment("MM/DD/YY") }}</td>
        <td class="text-xs-right">{{ item.expiration_date | moment("MM/DD/YY") }}</td>
        <td class="text-xs-right">
          <a :href="item.file_url" target="_blank">
            <v-icon>
              description
            </v-icon>
          </a>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>

export default {
  props: [
    'headers',
    'items',
  ],
  data: function() {
    return {
      defaultSort: {
        sortBy: 'start_date',
        descending: true,
      }
    }
  },
  methods: {
    isExpired(item) {
      return this.$moment(item.expiration_date).isBefore()
    }
  }
}
</script>
